import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import {CatalogPostcodeActions} from '../constants/catalog_postcode/catalog_postcode_actions';

class CatalogPostcodeStoreClass extends ReduceStore {
  getInitialState() {
    return {
      visible: false,
      showError: false,
    };
  }

  reduce(state, {source,action}) {
    const {type} = action;

    if (source === ACTION_TYPES.CATALOG_POSTCODE_ACTION) {
      switch (type) {
        case CatalogPostcodeActions.SHOW:
          if (!state.visible) {
            state.visible = true;
            this.__emitChange();
          }
          break;

        case CatalogPostcodeActions.HIDE:
          if (state.visible) {
            state.visible = false;
            this.__emitChange();
          }
          break;
        case CatalogPostcodeActions.SHOW_ERROR:
          if (!state.showError) {
            state.showError = true;
            this.__emitChange();
          }
          break;
        case CatalogPostcodeActions.HIDE_ERROR:
          if (state.showError) {
            state.showError = false;
            this.__emitChange();
          }
          break;
      }
    }

    return state;
  }
}

const CatalogPostcodeStore = new CatalogPostcodeStoreClass(Dispatcher);
export {CatalogPostcodeStore};